<header id="header">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-11">
        <nav class="navbar navbar-expand-lg navbar-light">
          <a href="https://www.reachr.com.br" class="navbar-brand logo mr-auto">
            <img src="assets/img/logo-reachr-branco.png" alt="logo_Reachr_Solucoes_Inovadoras_em_recursos_humanos" style='min-width: 100px !important;' class="img-fluid" loading="lazy">
          </a>
          <button class="navbar-toggler" type="button" (click)="abrirFecharMenu()">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse ml-auto" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="/vagas">Vagas</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/para-candidatos/avaliacao-comportamental" title='Avaliação Comportamental'>Avaliação Comportamental</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/para-candidatos/indice-empregabilidade" title='Índice de empregabilidade'>Índice de Empregabilidade</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://vagasti.reachr.com.br/">Vagas de TI</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href='https://blog.reachr.com.br/'>Blog</a>
              </li>
            </ul>
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link" class="btn-empresa" href="/"><span >Para<br>Empresas</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" class="btn-candidato" href="/paracandidatos/login">
                  Login<br>Cadastre-se
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>